import { FC } from 'react'
import RevokeButton from 'components/Button/RevokeButton'
import { useSubmitViolationItemDecision } from 'hooks'
import { Tooltip } from 'packages/eid-ui'

export const RejectRisk: FC<any> = (props) => {
    const { item, d } = props

    const { mutateAsync: submitRiskDecision, isLoading: isSubmitting } =
        useSubmitViolationItemDecision(
            'Requests',
            item.businessRequestId,
            item.id,
        )

    return (
        <Tooltip title={d.decisionFriendlyName}>
            <div>
                <RevokeButton
                    size={'small'}
                    onClick={() => {
                        const revokeReq = {
                            stepId: item.currentApprovalStepId,
                            decisionId: d.decisionId,
                        }
                        submitRiskDecision(revokeReq)
                    }}
                    loading={isSubmitting}
                />
            </div>
        </Tooltip>
    )
}
